<template>
  <div class="main-mask" v-if="visiable?true:false">
    <div class="dialog-contain " :style="getwidth()">
      <div class="dialog-header">
        <span>{{title?title:"提示"}}</span>
        <span class="dialog-close" @click="close"></span>
      </div>
      <div class="dialog-content">
        <slot name="dialog-content"></slot>
      </div>
    </div>
  </div>

</template>
<script>
  export default {

    name: "ey-dialog",
    props: ['title', 'visiable', 'width'],
    methods: {
      close() {
        this.$emit('update:visiable', false);
        // this.$emit('update:width', width);
      },
      getwidth() {
        if (this.width) {
          return "width:" + this.width;
        } else {
          return "width:600px"
        }
      }
    }
  }
</script>
<style lang="scss" type="text/scss" scoped>
  .main-mask {
    top: 0;
    bottom: 0;
    z-index: 1000;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    overflow: auto;
    margin: 0;
    display: flex;
    justify-content: center; //x轴排列
    align-items: center; //y轴排列
  }

  .dialog-contain {
    /*width: 600px;*/
    box-shadow: 0px 10px 10px 0px rgba(8, 1, 3, 0.1);
    position: relative;
    z-index: 999;
    border-radius: 4px;
    background: white;
    box-sizing: border-box;
    /*height: 2080px;*/
    /*top: 5%;*/
    /*top: 0;*/
    /*left: 0;*/
    /*right: 0;*/
    /*margin-left: auto;*/
    /*margin-right: auto;*/
  }

  .dialog-header {
    height: 50px;
    line-height: 50px;
    /*width: 600px;*/
    /*background: #DFE5EB;*/
    border-bottom: 1px solid #DEE3EA;
    padding-left: 20px;
    box-sizing: border-box;
    background-position: 100% 100%;

    span {
      font-size: 16px;
      font-weight: 400;
      color: #333;
    }
  }

  .dialog-content {
    box-sizing: border-box;
  }

  .dialog-close {
    position: absolute;
    right: 15px;
    top: 17px;
    width: 14px;
    cursor: pointer;
    height: 14px;
    display: inline-block;
    background: url("./btn_close_normal.png");

    &:hover {
      background: url("./btn_close_hl.png");
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/dialog/index.vue